'use client';

import { useAuth } from '@/context/AuthContext';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
    const { user, loading } = useAuth();
    const pathname = usePathname();

    const isPublicOrOtherPlatform =
        pathname === '/login' ||
        pathname === '/' ||
        pathname?.startsWith('/checkout') ||
        pathname?.startsWith('/pos/receipt') ||
        pathname?.startsWith('/kyc-complete') ||
        pathname?.startsWith('/cnv-transparencia') ||
        pathname?.startsWith('/cnv-riesgos') ||
        pathname?.startsWith('/wallet') ||
        pathname?.startsWith('/merchant') ||
        pathname?.startsWith('/developers') ||
        pathname?.startsWith('/master');

    useEffect(() => {
        if (!loading && !user) {
            if (!isPublicOrOtherPlatform) {
                // Redirección total e inmediata
                window.location.replace('/login');
            }
        }
    }, [user, loading, pathname, isPublicOrOtherPlatform]);

    // Loader de carga inicial (solo si aplica a Master)
    if (loading && !isPublicOrOtherPlatform) {
        return (
            <div className="flex h-screen w-full items-center justify-center bg-[#0a0f16]">
                <div className="flex flex-col items-center">
                    <div className="w-10 h-10 border-4 border-blue-500/20 border-t-blue-500 rounded-full animate-spin mb-4"></div>
                    <p className="text-gray-500 font-mono text-[10px] uppercase tracking-widest animate-pulse">Sincronizando Nodo...</p>
                </div>
            </div>
        );
    }

    // Estado intermedio para evitar flash de contenido privado
    if (!user && !isPublicOrOtherPlatform) {
        return (
            <div className="flex h-screen w-full items-center justify-center bg-[#0a0f16]">
                <div className="flex flex-col items-center">
                    <div className="w-10 h-10 border-4 border-blue-500/10 border-t-blue-500 rounded-full animate-spin mb-4"></div>
                </div>
            </div>
        );
    }

    return <>{children}</>;
}
